//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');

  curalate
    .constant('SHOWROOM_ACTION_TYPES', {
      ADD_NEW_INSTANCE: 'ADD_NEW_INSTANCE',
      INVALIDATE_SHOWROOM_CACHE: 'INVALIDATE_SHOWROOM_CACHE',
      LOAD_EXISTING_STATE: 'LOAD_EXISTING_STATE',
      REFRESH_PREVIEW_SECTION: 'REFRESH_PREVIEW_SECTION',
      REFRESH_PREVIEW_TEXT: 'REFRESH_PREVIEW_TEXT',
      RELOAD: 'RELOAD',
      SAVE: 'SAVE',
      SCROLL_TO_PREVIEW_SECTION: 'SCROLL_TO_PREVIEW_SECTION',
      START_ASYNC_CALL: 'START_ASYNC_CALL',
      STOP_ASYNC_CALL: 'STOP_ASYNC_CALL',
      SYNC_PREVIEW_SECTIONS: 'SYNC_PREVIEW_SECTIONS',
      TOGGLE_LOADING_PREVIEW_SECTION: 'TOGGLE_LOADING_PREVIEW_SECTION',
      TOGGLE_PREVIEW_SECTION: 'TOGGLE_PREVIEW_SECTION',
      UPDATE_ALL_PRODUCTS_CRAWLED: 'UPDATE_ALL_PRODUCTS_CRAWLED',
      UPDATE_FILTERS: 'UPDATE_FILTERS',
      UPDATE_IS_FIRST_LOAD: 'UPDATE_IS_FIRST_LOAD',
      UPDATE_LABELS: 'UPDATE_LABELS',
      UPDATE_PASSTHROUGH: 'UPDATE_PASSTHROUGH',
      UPDATE_PREVIEW: 'UPDATE_PREVIEW',
      UPDATE_PREVIEW_URL: 'UPDATE_PREVIEW_URL',
      UPDATE_PRODUCTS_LIST: 'UPDATE_PRODUCTS_LIST',
      UPDATE_USE_CURATED_RECS: 'UPDATE_USE_CURATED_RECS',
      UPDATE_TRACKING_PARAM_OVERRIDE: 'UPDATE_TRACKING_PARAM_OVERRIDE',
      UPDATE_TRACKING_PARAMS: 'UPDATE_TRACKING_PARAMS',
      UPDATE_PRODUCT_RECS: 'UPDATE_PRODUCT_RECS',
      UPDATE_MEDIA_RECS: 'UPDATE_MEDIA_RECS',
      UPDATE_EMAIL_CAPTURE: 'UPDATE_EMAIL_CAPTURE',
      UPDATE_CUSTOM_STRING: 'UPDATE_CUSTOM_STRING',
    })
    .constant('SHOWROOM_BUTTON_STATE', {
      DISABLED: 'DISABLED',
      DISABLED_NO_ERRORS: 'DISABLED_NO_ERRORS',
      LOADING: 'LOADING',
      READY: 'READY',
      SAVE_REQUIRED: 'SAVE_REQUIRED',
      SAVE_ERROR: 'SAVE_ERROR',
    })
    .constant('SHOWROOM_NAVIGATION_STATE', {
      NEXT_DISABLED: 'NEXT_DISABLED',
      READY: 'READY',
    })
    .constant('SHOWROOM_SETTINGS', {
      FILTERS: 'filters',
      PASSTHROUGH: 'passthrough',
      TRACKING_PARAMS: 'tracking_params',
      INSTANCES: 'instances',
    })
    .constant('SHOWROOM_CURATION_STATES', {
      CURALATE_RECS: 'curalate_recommendations',
      CURATED: 'curated',
      HIDDEN: 'hidden',
    })
    .constant('SHOWROOM_PREVIEW_SECTIONS', {
      TAGGED_PRODUCTS: 'TAGGED_PRODUCTS',
      PRODUCTS: 'PRODUCTS',
      MEDIA: 'MEDIA',
      EMAIL_CAPTURE: 'EMAIL_CAPTURE',
      NONE: 'NONE',
    })
    .constant('SHOWROOM_PREVIEW_TOGGLE_STATES', {
      HIDDEN: 'HIDDEN',
      VISIBLE: 'VISIBLE',
    })
    .constant('SHOWROOM_PREVIEW_DEFAULT_STRINGS', {
      EMAIL_CTA_DEFAULT: 'Sign up to receive special discounts.',
      TAGGED_PRODUCTS_DEFAULT: 'Shop the Look',
      RELATED_MEDIA_DEFAULT: 'More Looks',
      RECOMMENDED_PRODUCTS_DEFAULT: 'Explore More Products',
    });

  /**
   * ShowroomService
   *
   * Handles data to power the Showroom UIA experience
   */
  curalate.service('ShowroomService', [
    '$log',
    'rx',
    'SessionVarsService',
    'SHOWROOM_ACTION_TYPES',
    'SHOWROOM_BUTTON_STATE',
    'SHOWROOM_NAVIGATION_STATE',
    'SHOWROOM_SETTINGS',
    'SHOWROOM_PREVIEW_SECTIONS',
    'SHOWROOM_CURATION_STATES',
    'SHOWROOM_PREVIEW_TOGGLE_STATES',
    'ShowroomApiService',
    'TrackingService',
    'UniversalImageActionsHelpers',
    'UniversalImageActionsService',
    'UniversalImageActionsView',
    function (
      $log,
      rx,
      SessionVarsService,
      SHOWROOM_ACTION_TYPES,
      SHOWROOM_BUTTON_STATE,
      SHOWROOM_NAVIGATION_STATE,
      SHOWROOM_SETTINGS,
      SHOWROOM_PREVIEW_SECTIONS,
      SHOWROOM_CURATION_STATES,
      SHOWROOM_PREVIEW_TOGGLE_STATES,
      ShowroomApiService,
      TrackingService,
      UniversalImageActionsHelpers,
      UniversalImageActionsService,
      UniversalImageActionsView,
    ) {
      // Dispatch loop observable
      const showroomActions = new rx.Subject();
      const outstandingAsyncActions = {};

      const self = this;

      const UTM_SOURCE = 'utm_source';
      const DEFAULT_TRACKING_PARAMETER_VALUE = 'curalate_showroom';

      const launchOptions =
        UniversalImageActionsService.getCurrentLaunchOptions();

      const isSelfServeV2Enabled = SessionVarsService.isFeatureEnabled(
        'showroom_self_serve_v2',
      );
      const isUrlTrackingParamsV2Enabled = SessionVarsService.isFeatureEnabled(
        'url_tracking_params_v2',
      );

      const TRACKING_CATEGORY =
        UniversalImageActionsHelpers.getTrackingCategory(
          UniversalImageActionsService.getCurrentPage(),
        );
      let TRACKING_ACTION = TrackingService.ACTION_TRIBUTARY;
      const TRACKING_LABELS = {
        TRACKING_PARAMS_OVERRIDE: 'TrackingParamsOverride', // was "UtmSourceChangeSaved" until generalized
        UPDATE_TRIBUTARY: 'UpdateTributaryImpl',
        CREATE_TRIBUTARY: 'GenerateShowroomLink',
        OPEN_TRIBUTARY: 'OpenShowroomUIA',
      };

      let isInitialLoad = false;
      let existingState;

      const buildFiltersFromResponse = (response) => {
        if (response.filters) {
          return {
            shouldShow: true,
            onSaleFilter: {
              shouldShow: !_.isUndefined(response.filters.onSaleFilter),
              isSelected: !!response.filters.onSaleFilter,
            },
            brandFilter: {
              shouldShow: !_.isUndefined(response.filters.brandFilters),
              brands: _(response.filters.brandFilters).map((filter) => {
                return {
                  name: filter.name,
                  productIds: filter.productIds,
                  isSelected: filter.isSelected,
                };
              }),
            },
          };
        }

        return {
          shouldShow: false,
        };
      };

      const buildInstanceDtoFromInstance = (instance) => {
        let configToUse;
        if (instance && instance.instanceId) {
          configToUse = {
            trackingParams: {
              [instance.trackingParamOverrideName]:
                instance.trackingParamOverrideValue ||
                DEFAULT_TRACKING_PARAMETER_VALUE,
            },
          };
        }

        return {
          instanceId: instance.instanceId,
          url: instance.longLink,
          shortLink: instance.shortLink,
          config: configToUse,
        };
      };

      const buildInstanceFromInstanceDto = (instance) => {
        const overridenInstanceTrackingParameters = _(instance).safeGet(
          'overridenInstanceTrackingParameters',
        );
        const overridenNames = _.keys(overridenInstanceTrackingParameters);
        let trackingParamOverrideName = '';
        let trackingParamOverrideValue = '';

        // Use the nonMergedTrackingParameters (which after initial modification only should contain one parameter
        // for secondary instances) to get the current value. It is initially seeded with all of the tracking parameters
        if (_(overridenNames).size === 1) {
          trackingParamOverrideName = overridenNames[0];
        } else if (overridenNames.indexOf(UTM_SOURCE) > -1) {
          trackingParamOverrideName = UTM_SOURCE;
        } else {
          trackingParamOverrideName = overridenNames[0] || UTM_SOURCE;
        }
        if (overridenInstanceTrackingParameters) {
          trackingParamOverrideValue =
            overridenInstanceTrackingParameters[trackingParamOverrideName] ||
            DEFAULT_TRACKING_PARAMETER_VALUE;
        } else {
          trackingParamOverrideValue = DEFAULT_TRACKING_PARAMETER_VALUE;
        }

        return {
          instanceId: instance.instanceId,
          urlToShow: instance.shortLink || instance.url, // TODO Can remove once multilinks is shipped
          longLink: instance.url,
          shortLink: instance.shortLink,
          instanceTrackingParameters: _(instance.config).safeGet(
            'trackingParams',
          ),
          trackingParamOverrideName,
          trackingParamOverrideValue,
          hasCopiedLink: false, // TODO Can remove once multilinks is shipped
          shortLinkOutstandingAsync: null, // TODO Can remove once multilinks is shipped
          createdAt: instance.createdAt,
        };
      };

      const buildInstancesFromResponse = (response) => {
        return _(response.instances).map((instance) => {
          return buildInstanceFromInstanceDto(instance);
        });
      };

      const getCuralateTrackingParamKey = (response) => {
        if (isUrlTrackingParamsV2Enabled) {
          // For V2, the control of the reserved parameter was moved to the url-tracking service so that it is
          // can be used across touchpoints
          return _(response).safeGet('trackingReservedParameterName');
        } else {
          // The default is utm_medium for most clients, but some pilot clients were set up using utm_content
          // therefore we'll want to check that we're disabling the current param
          return (
            _(response).safeGet(
              'implementation.meta.curalateTrackingParamKey',
            ) || 'utm_medium'
          );
        }
      };

      const getContentToggleState = (state) => {
        return state === SHOWROOM_CURATION_STATES.HIDDEN
          ? SHOWROOM_PREVIEW_TOGGLE_STATES.HIDDEN
          : SHOWROOM_PREVIEW_TOGGLE_STATES.VISIBLE;
      };

      const getEmailToggleState = (state) => {
        return state && state.isEnabled
          ? SHOWROOM_PREVIEW_TOGGLE_STATES.VISIBLE
          : SHOWROOM_PREVIEW_TOGGLE_STATES.HIDDEN;
      };

      const buildStateFromResponse = (response) => {
        const newState = {};
        newState.impl = response.implementation;

        newState.isFirstLoad = response.isFirstLoad;
        newState.hasBeenUpdated = response.hasBeenUpdated;

        //
        // Preview Urls
        //

        newState.previewUrl = response.previewUrls.url;
        newState.embeddedMobilePreviewUrl =
          response.previewUrls.embeddedMobilePreviewUrl;
        newState.wysiwygMobilePreviewUrl =
          response.previewUrls.wysiwygMobilePreviewUrl;
        newState.externalDesktopPreviewUrl =
          response.previewUrls.externalDesktopPreviewUrl;

        //
        // Passthrough state
        //
        newState.passthrough = {
          passthroughUrl: response.passthroughUrl,
          showDesktopExperience: response.showDesktopExperience,
        };

        //
        // Tracking params state
        //
        newState.trackingParams = {
          curalateTrackingParamKey: getCuralateTrackingParamKey(response),
          trackingParamsString: _(response).safeGet(
            'implementation.meta.trackingParameters',
          ),
        };

        //
        // URLs state
        //
        newState.instances = buildInstancesFromResponse(response);

        //
        // Automatic Product Recs Filters state
        //
        newState.filters = {
          filterState: buildFiltersFromResponse(response),
        };

        //
        // Product information
        //
        newState.allProductsCrawled = response.allProductsCrawled;
        newState.hasProductCatalog = response.hasProductCatalog;

        //
        // Additional Module Configs
        //
        newState.emailCaptureState = response.emailCaptureConfig || {};
        newState.customStringsState = response.customStringsConfig || {};

        //
        // Manually Curated Recommendations
        //

        newState.curatedRecsId = _(response).safeGet(
          'implementation.meta.curatedRecsId',
        );
        newState.useCuratedRecommendations =
          !!response.useCuratedRecommendations;

        newState.curatedProducts = response.curatedProducts || [];
        newState.selectedLabels = response.selectedLabels || [];

        // If we're we're using the showroom wysiwyg preview, we need to determine the curation states
        // for both media and products.
        newState.curatedProductsState = response.productContentState;
        newState.curatedMediaState = response.mediaContentState;

        //
        // WYSIWYG section toggles (all sections hidden by default)
        //

        newState.previewToggleStates = {};

        newState.previewToggleStates[SHOWROOM_PREVIEW_SECTIONS.PRODUCTS] =
          getContentToggleState(newState.curatedProductsState);
        newState.previewToggleStates[SHOWROOM_PREVIEW_SECTIONS.MEDIA] =
          getContentToggleState(newState.curatedMediaState);
        newState.previewToggleStates[SHOWROOM_PREVIEW_SECTIONS.EMAIL_CAPTURE] =
          getEmailToggleState(newState.emailCaptureState);

        //
        // Current content state
        //

        newState.tributaryContent = response.tributaryContent;

        return newState;
      };

      const reduceInstanceStateToSavedStateCheck = (instance) => {
        return {
          instanceId: instance.instanceId,
          trackingParamOverrideName: instance.trackingParamOverrideName,
          trackingParamOverrideValue: instance.trackingParamOverrideValue,
        };
      };

      const reduceStateToSavedStateCheck = (state) => {
        const currentInstances = _(state).safeGet('instances') || [];
        const showDesktopExperience = _(state).safeGet(
          'passthrough.showDesktopExperience',
        );
        const recommendedProductIds = _(state.curatedProducts).pluck(
          'productStyleId',
        );
        const sortedLabels = _(state.selectedLabels)
          .map((label) => {
            return label.toLowerCase();
          })
          .sort();
        const saveState = {
          instances: _(currentInstances).map((instance) => {
            return reduceInstanceStateToSavedStateCheck(instance);
          }),
          filters: state.useCuratedRecommendations
            ? {}
            : _(state).safeGet('filters.filterState'),
          trackingParams: _(state).safeGet(
            'trackingParams.trackingParamsString',
          ),
          showDesktopExperience,
          useCuratedRecommendations: state.useCuratedRecommendations,
          recommendedProductIds: state.useCuratedRecommendations
            ? recommendedProductIds
            : [],
          selectedLabels: sortedLabels,
          curatedProductsState: state.curatedProductsState,
          curatedMediaState: state.curatedMediaState,
          emailCaptureState: state.emailCaptureState,
          customStringsState: state.customStringsState,
        };

        // We only need to check the passthroughUrl if showDesktopExperience is disabled since
        // the passthrough doesn't matter otherwise
        if (!showDesktopExperience) {
          saveState.passthroughUrl = _(state).safeGet(
            'passthrough.passthroughUrl',
          );
        }
        return saveState;
      };

      const stateContainsErrors = (state) => {
        // There are two ways to get into a true "error" state at the time of writing.
        // One is to have empty custom tracking params. The other is to have an undefined custom passthroughUrl
        const showDesktop = _(state).safeGet(
          'passthrough.showDesktopExperience',
        );
        const passthroughUrlError =
          !showDesktop && !_(state).safeGet('passthrough.passthroughUrl');

        const trackingParamsString =
          _(state).safeGet('trackingParams.trackingParamsString') || '';

        const hadGaParamsOnInit = _(state).safeGet(
          'trackingParams.hadGaParamsOnInit',
        );

        const trackingParamsError =
          hadGaParamsOnInit && trackingParamsString.indexOf(UTM_SOURCE) === -1;

        return passthroughUrlError || trackingParamsError;
      };

      const getButtonStateForNewState = (newState) => {
        const currentWorkflow =
          UniversalImageActionsService.getCurrentWorkflow();
        const finalPreviewPanel =
          UniversalImageActionsView.TributaryCustomizeLinks.name;
        if (
          isSelfServeV2Enabled &&
          !newState.hasBeenUpdated &&
          currentWorkflow.getCurrentState() !== finalPreviewPanel
        ) {
          return SHOWROOM_BUTTON_STATE.DISABLED_NO_ERRORS;
        } else {
          if (
            !newState.loaded ||
            _(newState.outstandingAsyncActions).contains(
              SHOWROOM_ACTION_TYPES.RELOAD,
            )
          ) {
            return SHOWROOM_BUTTON_STATE.LOADING;
          }

          if (stateContainsErrors(newState)) {
            return SHOWROOM_BUTTON_STATE.DISABLED;
          }

          const newSavedState = reduceStateToSavedStateCheck(newState);
          const stateChanged = !angular.equals(
            newState.currentSavedState,
            newSavedState,
          );

          if (stateChanged) {
            return SHOWROOM_BUTTON_STATE.SAVE_REQUIRED;
          }
          return SHOWROOM_BUTTON_STATE.READY;
        }
      };

      const shouldShowSkipToEnd = () => {
        const currentWorkflow =
          UniversalImageActionsService.getCurrentWorkflow();
        const finalPreviewPanel =
          UniversalImageActionsView.TributaryCustomizeLinks.name;
        return (
          isSelfServeV2Enabled &&
          currentWorkflow.getCurrentState() !== finalPreviewPanel
        );
      };

      const getNavigationStateForNewState = (newState) => {
        const currentWorkflow =
          UniversalImageActionsService.getCurrentWorkflow();
        const firstPreviewPanel =
          UniversalImageActionsView.TributaryCustomizeProducts.name;
        const productizePanel = UniversalImageActionsView.Productize.name;
        // On the first WYSIWYG panel, disable navigation until the preview finishes loading
        if (
          (isSelfServeV2Enabled &&
            !newState.previewLoaded &&
            currentWorkflow.getCurrentState() === firstPreviewPanel) ||
          (UniversalImageActionsService.getNumTaggedProducts() < 1 &&
            currentWorkflow.getCurrentState() === productizePanel)
        ) {
          return SHOWROOM_NAVIGATION_STATE.NEXT_DISABLED;
        } else {
          return SHOWROOM_NAVIGATION_STATE.READY;
        }
      };

      const checkStateForTrackingParamsOverrideChangedEvent = (newState) => {
        const newSavedState = reduceStateToSavedStateCheck(newState);
        const instancesChanged = !angular.equals(
          newState.currentSavedState.instances,
          newSavedState.instances,
        );
        if (instancesChanged) {
          TrackingService.recordEvent(
            TRACKING_CATEGORY,
            this.getTrackingAction(),
            TRACKING_LABELS.TRACKING_PARAMS_OVERRIDE,
          );
        }
      };

      const stopAsyncAction = (name) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.STOP_ASYNC_CALL,
          name,
        });
      };

      const startAsyncAction = (name, resetLoaded) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.START_ASYNC_CALL,
          name,
          resetLoaded,
        });
      };

      // Dispatch loop & Observable for consumers
      const showroomConfigStatus = showroomActions
        .scan((state, action) => {
          let newState = angular.copy(state);
          switch (action.type) {
            case SHOWROOM_ACTION_TYPES.ADD_NEW_INSTANCE: {
              newState.instances.push(action.instance);

              // The newly added instance state shouldn't impact the current status of the button, so update currentSavedState
              const instanceSavedState = reduceInstanceStateToSavedStateCheck(
                action.instance,
              );
              newState.currentSavedState.instances.push(instanceSavedState);
              break;
            }
            case SHOWROOM_ACTION_TYPES.INVALIDATE_SHOWROOM_CACHE: {
              if (state.impl) {
                // Only clear the cache if we have valid implementation state loaded.
                ShowroomApiService.clearTributaryImplCache(
                  state.impl.id,
                  state.impl.name,
                );
              }
              break;
            }
            case SHOWROOM_ACTION_TYPES.RELOAD: {
              newState = angular.copy(action.state);
              newState.universalItemId = action.universalItemId;
              newState.loaded = true;

              // Ensure the button goes to "Ready" state
              const savedState = reduceStateToSavedStateCheck(
                angular.copy(newState),
              );
              newState.currentSavedState = savedState;
              break;
            }
            case SHOWROOM_ACTION_TYPES.LOAD_EXISTING_STATE: {
              // Loads the state without wiping out newState.currentSavedState
              newState = angular.copy(action.state);
              newState.universalItemId = action.universalItemId;
              newState.loaded = true;
              break;
            }
            case SHOWROOM_ACTION_TYPES.SAVE: {
              checkStateForTrackingParamsOverrideChangedEvent(newState);
              // Ensure the buttons go to "Ready" state by resetting the currently saved state
              const savedState = reduceStateToSavedStateCheck(
                angular.copy(newState),
              );
              newState.currentSavedState = savedState;
              break;
            }
            case SHOWROOM_ACTION_TYPES.START_ASYNC_CALL: {
              if (!newState.outstandingAsyncActions) {
                newState.outstandingAsyncActions = [];
              }
              newState.outstandingAsyncActions.push(action.name);
              if (action.resetLoaded) {
                newState.loaded = false;
              }
              break;
            }
            case SHOWROOM_ACTION_TYPES.STOP_ASYNC_CALL: {
              newState.outstandingAsyncActions = _(
                newState.outstandingAsyncActions,
              ).without(action.name);
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_ALL_PRODUCTS_CRAWLED: {
              newState.allProductsCrawled = action.state.allProductsCrawled;
              newState.tributaryContent = action.state.tributaryContent;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_FILTERS: {
              newState.filters.filterState = action.filterState;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_LABELS: {
              newState.selectedLabels = action.labels;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_USE_CURATED_RECS: {
              newState.useCuratedRecommendations = action.state;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_PRODUCT_RECS: {
              newState.curatedProductsState = action.productsState;
              newState.useCuratedRecommendations = this.getCuratedRecsBoolean(
                action.productsState,
                newState.curatedMediaState,
              );
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_MEDIA_RECS: {
              newState.curatedMediaState = action.mediaState;
              newState.useCuratedRecommendations = this.getCuratedRecsBoolean(
                newState.curatedProductsState,
                action.mediaState,
              );
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_TRACKING_PARAM_OVERRIDE: {
              const instanceRef = _(newState.instances).find((instance) => {
                return instance.instanceId === action.instanceId;
              });
              instanceRef.trackingParamOverrideName =
                action.trackingParamOverrideName;
              instanceRef.trackingParamOverrideValue =
                action.trackingParamOverrideValue;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_PASSTHROUGH: {
              newState.passthrough.passthroughUrl = action.passthroughUrl;
              newState.passthrough.showDesktopExperience =
                action.showDesktopExperience;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW_URL: {
              newState.previewUrl = action.previewUrl;
              newState.embeddedMobilePreviewUrl =
                action.embeddedMobilePreviewUrl;
              newState.wysiwygMobilePreviewUrl = action.wysiwygMobilePreviewUrl;
              newState.externalDesktopPreviewUrl =
                action.externalDesktopPreviewUrl;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW:
              newState.previewSectionToUpdate =
                action.sectionToUpdate || SHOWROOM_PREVIEW_SECTIONS.NONE;
              // Most state updates occur on the frontend before the backend preview update completes.
              // However the following two pieces of state are updated on the backend.
              newState.tributaryContent = action.state.tributaryContent;
              newState.curatedProducts = action.state.curatedProducts;
              break;
            case SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_SECTION: {
              newState.previewSectionToUpdate =
                action.sectionToUpdate || SHOWROOM_PREVIEW_SECTIONS.NONE;
              break;
            }
            case SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_TEXT: {
              newState.previewTextToUpdate =
                action.sectionToUpdate || SHOWROOM_PREVIEW_SECTIONS.NONE;
              break;
            }
            case SHOWROOM_ACTION_TYPES.SCROLL_TO_PREVIEW_SECTION: {
              newState.previewSectionToScrollTo =
                action.sectionToScrollTo || SHOWROOM_PREVIEW_SECTIONS.NONE;
              break;
            }
            case SHOWROOM_ACTION_TYPES.TOGGLE_LOADING_PREVIEW_SECTION: {
              newState.previewSectionToToggleLoad =
                action.sectionToToggle || SHOWROOM_PREVIEW_SECTIONS.NONE;
              break;
            }
            case SHOWROOM_ACTION_TYPES.TOGGLE_PREVIEW_SECTION: {
              const currentPreviewToggleStates = angular.copy(
                existingState.previewToggleStates,
              );
              const newPreviewToggleStates = {};

              newPreviewToggleStates[SHOWROOM_PREVIEW_SECTIONS.PRODUCTS] =
                action.productsState
                  ? getContentToggleState(action.productsState)
                  : null;
              newPreviewToggleStates[SHOWROOM_PREVIEW_SECTIONS.MEDIA] =
                action.mediaState
                  ? getContentToggleState(action.mediaState)
                  : null;
              newPreviewToggleStates[SHOWROOM_PREVIEW_SECTIONS.EMAIL_CAPTURE] =
                action.emailState
                  ? getEmailToggleState(action.emailState)
                  : null;

              newState.previewToggleStates = _(
                currentPreviewToggleStates,
              ).extend(newPreviewToggleStates);
              break;
            }
            case SHOWROOM_ACTION_TYPES.SYNC_PREVIEW_SECTIONS: {
              newState.previewLoaded = true;
              // Set up the toggle states according to the existing curation states
              newState.previewToggleStates = {};
              newState.previewToggleStates[SHOWROOM_PREVIEW_SECTIONS.PRODUCTS] =
                getContentToggleState(newState.curatedProductsState);
              newState.previewToggleStates[SHOWROOM_PREVIEW_SECTIONS.MEDIA] =
                getContentToggleState(newState.curatedMediaState);
              newState.previewToggleStates[
                SHOWROOM_PREVIEW_SECTIONS.EMAIL_CAPTURE
              ] = getEmailToggleState(newState.emailCaptureState);
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_HAS_BEEN_UPDATED: {
              newState.hasBeenUpdated = true;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_PRODUCTS_LIST: {
              newState.curatedProducts = action.products;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_TRACKING_PARAMS: {
              newState.trackingParams.trackingParamsString =
                action.trackingParamsString;
              newState.trackingParams.hadGaParamsOnInit =
                action.hadGaParamsOnInit;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_EMAIL_CAPTURE: {
              newState.emailCaptureState = action.emailCaptureState;
              break;
            }
            case SHOWROOM_ACTION_TYPES.UPDATE_CUSTOM_STRING: {
              newState.customStringsState = action.customStringsState;
              break;
            }
            default: {
              $log.error(`unrecognized type: ${action.type}`);
              break;
            }
          }

          newState.buttonState = getButtonStateForNewState(newState);
          newState.showSkipToEnd = shouldShowSkipToEnd();
          newState.navigationState = getNavigationStateForNewState(newState);
          existingState = newState;

          return newState;
        }, {})
        .share();

      this.loadExistingState = (universalItemId) => {
        if (
          angular.isDefined(existingState) &&
          existingState.universalItemId === universalItemId
        ) {
          const currentWorkflow =
            UniversalImageActionsService.getCurrentWorkflow();
          const customizeProductsPreviewPanel =
            UniversalImageActionsView.TributaryCustomizeProducts.name;

          showroomActions.next({
            type: SHOWROOM_ACTION_TYPES.LOAD_EXISTING_STATE,
            state: existingState,
            universalItemId,
          });

          // Ensure we have the latest product information
          if (
            currentWorkflow.getCurrentState() === customizeProductsPreviewPanel
          ) {
            this.updateAllProductsCrawled(universalItemId);
          }
        } else {
          this.reloadState(universalItemId);
        }
      };

      this.addNewInstance = (universalItemId, implId, implName) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.ADD_NEW_INSTANCE;
        if (outstandingAsyncActions[ASYNC_ACTION]) {
          return;
        }
        startAsyncAction(ASYNC_ACTION);
        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.addTributaryInstanceForItemAsync(
            universalItemId,
            implId,
            implName,
          )
            .then((response) => {
              const instanceDto = response.instance;
              const instance = buildInstanceFromInstanceDto(instanceDto);
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.ADD_NEW_INSTANCE,
                instance,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
            });
      };

      this.buildTrackingParamsString = (trackingParams, forPreview) => {
        const joinChar = forPreview ? '&\n' : ',';
        const filteredParamArray = _.chain(trackingParams)
          .map((value, key) => {
            return [key, value];
          })
          .filter((keyValArr) => {
            return !!keyValArr[0] && !!keyValArr[1];
          })
          .value();

        return _(filteredParamArray)
          .map((keyValArr) => {
            const key = encodeURIComponent(keyValArr[0]);
            const value = encodeURIComponent(keyValArr[1]);
            return `${key}=${value}`;
          })
          .join(joinChar);
      };

      this.saveImplementation = (
        implId,
        implName,
        implType,
        sourceId,
        universalItemId,
        passthroughUrl,
        trackingParamsString,
        filterState,
        instances,
        showDesktop,
        emailCaptureState,
        customStringsState,
        curatedRecsId,
        useCuratedRecommendations,
        curatedProducts,
        selectedLabels,
        productContentState,
        mediaContentState,
      ) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.SAVE;
        const instanceDtos = _(instances).map((instance) => {
          return buildInstanceDtoFromInstance(instance);
        });

        if (outstandingAsyncActions[ASYNC_ACTION]) {
          return;
        }

        startAsyncAction(ASYNC_ACTION);

        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.updateTributaryImplAsync(
            implId,
            implName,
            implType,
            sourceId,
            universalItemId,
            passthroughUrl,
            trackingParamsString,
            filterState,
            instanceDtos,
            showDesktop,
            emailCaptureState,
            customStringsState,
            curatedRecsId,
            useCuratedRecommendations,
            curatedProducts,
            selectedLabels,
            productContentState,
            mediaContentState,
            true,
          )
            .then((result) => {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                self.getTrackingAction(),
                TRACKING_LABELS.UPDATE_TRIBUTARY,
              );
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.SAVE,
                state: result,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
              // Any time the showroom is updated, invalidate the cache;
              this.invalidateShowroomCache();
            });
      };

      this.updateInstanceTrackingParamOverride = (
        instanceId,
        trackingParamOverrideName,
        trackingParamOverrideValue,
      ) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_TRACKING_PARAM_OVERRIDE,
          instanceId,
          trackingParamOverrideName,
          trackingParamOverrideValue,
        });
      };

      this.updateLabels = (labels) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_LABELS,
          labels,
        });
      };

      this.updatePassthrough = (showDesktopExperience, passthroughUrl) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_PASSTHROUGH,
          showDesktopExperience,
          passthroughUrl,
        });
      };

      this.updateFilters = (filterState) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_FILTERS,
          filterState,
        });
      };

      this.updatePreviewUrl = (
        itemId,
        implId,
        implName,
        filterState,
        showDesktopExperience,
        passthroughUrl,
        useCuratedRecommendations,
        curatedProducts,
        selectedLabels,
        callback,
      ) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW_URL;
        const curatedProductIds = _(curatedProducts).pluck('productStyleId');

        if (outstandingAsyncActions[ASYNC_ACTION]) {
          return;
        }

        startAsyncAction(ASYNC_ACTION);
        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.getTributaryPreviewUrlAsync(
            itemId,
            implId,
            implName,
            filterState,
            showDesktopExperience,
            passthroughUrl,
            useCuratedRecommendations,
            curatedProductIds,
            selectedLabels,
          )
            .then((result) => {
              if (angular.isFunction(callback)) callback();
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW_URL,
                previewUrl: result.url,
                embeddedMobilePreviewUrl: result.embeddedMobilePreviewUrl,
                wysiwygMobilePreviewUrl: result.wysiwygMobilePreviewUrl,
                externalDesktopPreviewUrl: result.externalDesktopPreviewUrl,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
            });
      };

      this.updatePreview = (
        itemId,
        implId,
        implName,
        implType,
        sourceId,
        filterState,
        showDesktopExperience,
        passthroughUrl,
        emailCaptureState,
        customStringsState,
        curatedRecsId,
        useCuratedRecommendations,
        curatedProducts,
        selectedLabels,
        productContentState,
        mediaContentState,
        sectionToUpdate,
        callback,
      ) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW;

        if (outstandingAsyncActions[ASYNC_ACTION]) {
          return;
        }

        startAsyncAction(ASYNC_ACTION);

        // Check to see if we should toggle a preview section
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.TOGGLE_PREVIEW_SECTION,
          productsState: productContentState,
          mediaState: mediaContentState,
        });

        // Trigger a scroll action
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.SCROLL_TO_PREVIEW_SECTION,
          sectionToScrollTo: sectionToUpdate,
        });

        // Trigger a the loading preview
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.TOGGLE_LOADING_PREVIEW_SECTION,
          sectionToToggle: sectionToUpdate,
        });

        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.updatePreviewImplAsync(
            implId,
            implName,
            implType,
            sourceId,
            itemId,
            passthroughUrl,
            filterState,
            showDesktopExperience,
            emailCaptureState,
            customStringsState,
            curatedRecsId,
            useCuratedRecommendations,
            curatedProducts,
            selectedLabels,
            productContentState,
            mediaContentState,
            false,
          )
            .then((result) => {
              if (angular.isFunction(callback)) callback();
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.UPDATE_PREVIEW,
                state: result,
                sectionToUpdate,
              });

              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.TOGGLE_LOADING_PREVIEW_SECTION,
                sectionToToggle: sectionToUpdate,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
            });
      };

      this.resetPreviewSectionToToggleLoad = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.TOGGLE_LOADING_PREVIEW_SECTION,
          sectionToUpdate: SHOWROOM_PREVIEW_SECTIONS.NONE,
        });
      };

      this.resetPreviewSectionToRefresh = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_SECTION,
          sectionToUpdate: SHOWROOM_PREVIEW_SECTIONS.NONE,
        });
      };

      this.resetPreviewTextToRefresh = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_TEXT,
          sectionToUpdate: SHOWROOM_PREVIEW_SECTIONS.NONE,
        });
      };

      this.resetPreviewSectionToScrollTo = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.SCROLL_TO_PREVIEW_SECTION,
          sectionToScrollTo: SHOWROOM_PREVIEW_SECTIONS.NONE,
        });
      };

      this.syncPreviewSections = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.SYNC_PREVIEW_SECTIONS,
        });
      };

      this.updateHasBeenUpdated = () => {
        if (existingState.loaded && !existingState.hasBeenUpdated) {
          this.saveImplementation(
            existingState.impl.id,
            existingState.impl.name,
            existingState.impl.implementationType,
            existingState.impl.sourceId,
            existingState.universalItemId,
            existingState.passthrough.passthroughUrl,
            existingState.trackingParams.trackingParamsString,
            existingState.filters.filterState,
            existingState.instances,
            existingState.passthrough.showDesktopExperience,
            existingState.emailCaptureState,
            existingState.customStringsState,
            existingState.curatedRecsId,
            existingState.useCuratedRecommendations,
            existingState.curatedProducts,
            existingState.selectedLabels,
            existingState.curatedProductsState,
            existingState.curatedMediaState,
          );
        }

        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_HAS_BEEN_UPDATED,
        });
      };

      this.updateProductsList = (productList) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_PRODUCTS_LIST,
          products: productList,
        });
      };

      this.updateTrackingParams = (trackingParams, hadGaParamsOnInit) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_TRACKING_PARAMS,
          trackingParamsString: this.buildTrackingParamsString(trackingParams),
          hadGaParamsOnInit,
        });
      };

      this.updateEmailCaptureState = (emailCaptureState) => {
        // Update email capture state
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_EMAIL_CAPTURE,
          emailCaptureState,
        });

        // Check to see if we should toggle a preview section
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.TOGGLE_PREVIEW_SECTION,
          emailState: emailCaptureState,
        });

        // Scroll to email capture module
        if (emailCaptureState.isEnabled) {
          showroomActions.next({
            type: SHOWROOM_ACTION_TYPES.SCROLL_TO_PREVIEW_SECTION,
            sectionToScrollTo: SHOWROOM_PREVIEW_SECTIONS.EMAIL_CAPTURE,
          });
        }

        // Update email CTA in the wysiwyg preview
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_TEXT,
          sectionToUpdate: SHOWROOM_PREVIEW_SECTIONS.EMAIL_CAPTURE,
        });
      };

      this.updateCustomStringState = (customStringsState, sectionToUpdate) => {
        // Update custom string state
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_CUSTOM_STRING,
          customStringsState,
        });

        // Update string in wysiwyg preview
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.REFRESH_PREVIEW_TEXT,
          sectionToUpdate,
        });
      };

      this.reloadState = (universalItemId) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.RELOAD;

        const showroomLaunchContext =
          launchOptions.getShowroomLaunchContext() || {};
        const implType = showroomLaunchContext.implementationType;
        const sourceId = showroomLaunchContext.sourceId;

        if (outstandingAsyncActions[ASYNC_ACTION]) {
          return;
        }

        startAsyncAction(ASYNC_ACTION, true);
        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.getTributaryImplAsync(
            universalItemId,
            implType,
            sourceId,
          )
            .then((response) => {
              if (!response.implementation) {
                // We call "reloadState" when the user navigates to the productize panel of UIA
                // from within the Showroom workflow to enable us to invalidate the cache when new
                // tags are added, at which point there may or may not be  an existing Showroom implementation.
                // In this case its fine to simply return without initializing the service state.
                return;
              }

              // If this is the first "re"load of Showroom content into UIA,
              // log the appropriate GA metrics
              if (!isInitialLoad) {
                isInitialLoad = true;

                if (response.isFirstLoad) {
                  TRACKING_ACTION = TrackingService.ACTION_TRIBUTARY_CREATE;
                  TrackingService.recordEvent(
                    TRACKING_CATEGORY,
                    TRACKING_ACTION,
                    TRACKING_LABELS.CREATE_TRIBUTARY,
                  );
                } else {
                  TRACKING_ACTION = TrackingService.ACTION_TRIBUTARY_UPDATE;
                  TrackingService.recordEvent(
                    TRACKING_CATEGORY,
                    TRACKING_ACTION,
                    TRACKING_LABELS.OPEN_TRIBUTARY,
                  );
                }
              }

              const newState = buildStateFromResponse(response);
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.RELOAD,
                state: newState,
                universalItemId,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
            });
      };

      this.setUseCuratedRecommendations = (newState) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_USE_CURATED_RECS,
          state: newState,
        });
      };

      this.onUpdateCuratedMediaState = (mediaState) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_MEDIA_RECS,
          mediaState,
        });
      };

      this.onUpdateCuratedProductsState = (productsState) => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.UPDATE_PRODUCT_RECS,
          productsState,
        });
      };

      this.getTrackingAction = () => {
        if (isSelfServeV2Enabled) {
          const currentWorkflow =
            UniversalImageActionsService.getCurrentWorkflow();
          return `${TRACKING_ACTION}:${currentWorkflow.getCurrentState()}`;
        } else {
          return TRACKING_ACTION;
        }
      };

      this.getTrackingCategory = () => {
        return TRACKING_CATEGORY;
      };

      this.getCurrentConfigStatusObservable = () => {
        return showroomConfigStatus;
      };

      this.getDefaultTrackingParameterValue = () => {
        return DEFAULT_TRACKING_PARAMETER_VALUE;
      };

      this.invalidateShowroomCache = () => {
        showroomActions.next({
          type: SHOWROOM_ACTION_TYPES.INVALIDATE_SHOWROOM_CACHE,
        });
      };

      this.getCuratedRecsBoolean = (productsState, mediaState) => {
        return (
          productsState === SHOWROOM_CURATION_STATES.CURATED ||
          mediaState === SHOWROOM_CURATION_STATES.CURATED
        );
      };

      this.updateAllProductsCrawled = (universalItemId) => {
        const ASYNC_ACTION = SHOWROOM_ACTION_TYPES.UPDATE_ALL_PRODUCTS_CRAWLED;

        outstandingAsyncActions[ASYNC_ACTION] =
          ShowroomApiService.getProductsInfoAsync(universalItemId)
            .then((response) => {
              showroomActions.next({
                type: SHOWROOM_ACTION_TYPES.UPDATE_ALL_PRODUCTS_CRAWLED,
                state: response,
              });
            })
            .finally(() => {
              stopAsyncAction(ASYNC_ACTION);
              delete outstandingAsyncActions[ASYNC_ACTION];
            });
      };
    },
  ]);
})();
